
define('plugins/backbone/socketio',[],function() {

	var opts = {'sync disconnect on unload': false};

	// We only want to do this if we are not already connected.
	if(!window.socket) {
		// Unfortunatly becasue of nested subdomains for profiles with dots in the uersnames we cannot stick to https, so we do this switcharoo business, where e have both http and https
		// Lets get get the main www domain, some parsing may need to be done on profile subdomains
		//var d = (window.location.host.split(".")[0] == "www" ? window.location.host : "www."+_.rest(window.location.host.split(".")).join("."));
		// (window.location.protocol == 'https:' ? _.extend(opts, {secure: true}) : opts)
		window.socket = io.connect("//" + window.location.host, opts);

		window.socket.on('connect_failed', function(){
		    throw "Error connecting via the socket";
		});
	}


	// Custom Ready Function for Backbone Models

	ready = function() {

		if(!this.isLoaded) {
			this.isLoaded = true;
			this.trigger("nasoidnosiadnasoidnsa");

			// Lets remove this object from our list of waiting.

			// var l = window.ObjectsStillLoading.length;
			// var before = _.map(window.ObjectsStillLoading, function(e) { return e.cid; });
			window.ObjectsStillLoading = _.filter(window.ObjectsStillLoading, function(element) {
				return element !== this;
			}, this);
			//console.log(l, window.ObjectsStillLoading.length, this.cid, before);
		}

	};

	window.ObjectsStillLoading = [];

	onReady = function(method, context) {

		if(this.isLoaded) {
			method.apply((context ? context : this));
		} else {
			window.ObjectsStillLoading.push(this);
			this.once("nasoidnosiadnasoidnsa", method, (context ? context : this));
		}

	};


	Backbone.Model.prototype.ready = ready;
	Backbone.View.prototype.ready = ready;
	Backbone.Collection.prototype.ready = ready;

	Backbone.Model.prototype.onReady = onReady;
	Backbone.View.prototype.onReady = onReady;
	Backbone.Collection.prototype.onReady = onReady;

	window.transmitHistory = [];

	Backbone.sync = function (method, model, options) {

		var triggerReady = true;
		if(options.hasOwnProperty('triggerReady')) {
			triggerReady = options.triggerReady;
			delete options.triggerReady;
		}

		var getUrl = function (object) {
			if (!(object && object.url)) return null;
				return _.isFunction(object.url) ? object.url() : object.url;
		};

		var cmd = getUrl(model).split('/')
		, namespace = (cmd[0] !== '') ? cmd[0] : cmd[1]; // if leading slash, ignore

		var params = _.extend({
			req: namespace + ':' + method
		}, options);

		    // Ensure that we have the appropriate request data.
		if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
			params.data = options.attrs || model.toJSON(options);
		}

		if(!params.data) {
			params.data = model.toJSON() || {};
		}

		// we wanna make sure the id comes through
		if(model instanceof Backbone.Collection) {
			params.data = (options.data ? options.data : {});
		}

		// If your socket.io connection exists on a different var, change here:
		var io = model.socket || window.socket || Backbone.socket;

		// if(window.showPreTransmits && window.console && window.console.log)
		// 	window.console.warn([namespace + ':' + method, params.data]);

		window.transmitHistory.push([namespace + ':' + method, params.data, new Date()]);

		var start = new Date();

		var showError = function() {
			alert("There is a problem communicating with Social Psychology Network. Please copy any work you have open. Please check your connection and refresh your web browser. If you think this is an error with the Network, please contact us for assistance at administrator@socialpsychology.org.");
		};
		// After a timeout show a cannot connect message.
		var timeout = setTimeout(function() {
			showError();
		},10*1000);

		io.emit('backbone', _.extend(params.data, {wsa: namespace + ':' + method}), function (err, data) {

			clearTimeout(timeout);

			if(data && data.wsa) delete data.wsa;
			if(params.data && params.data.wsa) delete params.data.wsa;

			// Lets nto show this when compiling pages.
			if(!window.jsdom) {
				// Lets not log any passwords.
				if(params.data && params.data.password) delete params.data.password;

				console.log(namespace + ':' + method, params.data, data, (new Date().getTime() - start.getTime())/1000+"s");
				//console.log(namespace + ':' + method, {str: JSON.stringify(data)});
			}


			if (err) {
				if(options.errorCallback) {
					options.errorCallback();
				} else {
					showError();
					console.error(err);
					throw "Backbone Problem";
				}
			} else {
				options.success(data);
				if(triggerReady)
					model.ready();

			}
		});
	};

});
